import React, { Fragment, useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Col,
  InputGroup,
  Row,
} from "reactstrap";
import { Multiselect } from "react-widgets";
import {
  QUERY_GET_ALL_SDGS,
  QUERY_GET_ALL_ACTS,
  QUERY_GET_ALL_TARGET_AUDIENCE,
  QUERY_GET_ALL_SCALE_OF_ORG,
  QUERY_GET_ALL_COLLABORATION_NEEDS,
  QUERY_SEARCH_PROPS,
  QUERY_GET_ALL_COUNTRIES,
} from "../../../queries";
import { useQuery } from "@apollo/client";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import {
  GET_ALL_CERTIFICATIONS,
  GET_ALL_NETWORKS,
} from "../../../queries/networksAndCertifications";
import { prefectureOptions } from "../../../components/CSORegister/Steps/Step0";

const SearchBox = ({
  setSearchContext,
  context,
  search,
  queryParams,
  setQueryParams,
}) => {
  const [modal, setModal] = useState(false);
  const [modalFilter, setModalFilter] = useState(false);
  const [filterInput, setFilterInput] = useState({
    organizationName: "",
    sdgs: [],
    country: [],
    collaborationNeeds: [],
    activityFields: [],
    targetAudience: [],
    scaleOfOrg: [],
    address: [],
    legalStatus: [],
    networks: [],
    certifications: [],
  });

  const availableCountries = useQuery(QUERY_GET_ALL_COUNTRIES);

  const { data: availableNetworksData } = useQuery(GET_ALL_NETWORKS);
  const { data: availableCertificationsData } = useQuery(
    GET_ALL_CERTIFICATIONS,
    {
      errorPolicy: "ignore",
    }
  );

  const networksOptions = availableNetworksData?.allNetwork?.edges?.map(
    (edge) => {
      return {
        name: edge.node.title,
        id: edge.node.id,
      };
    }
  );
  const certificationsOptions =
    availableCertificationsData?.allThirdPartyCertificate?.edges?.map(
      (edge) => {
        return {
          title: edge.node.title,
          key: edge.node.id,
        };
      }
    );

  const { data: searchProps, loading: loadingSearchProps } =
    useQuery(QUERY_SEARCH_PROPS);

  let dropdownDataActs = searchProps?.allActivityfields.edges.map((edge) => {
    return {
      title: edge.node.name,
      id: edge.node.id,
    };
  });

  const dropdownDataCollaborationNeeds =
    searchProps?.allCollaborationNeeds?.edges?.map((edge) => {
      return {
        title: edge.node.title,
        id: edge.node.id,
      };
    });

  let dropdownDataTargetAudience = searchProps?.allTarget.edges.map((edge) => ({
    name: edge.node.name,
    id: edge.node.id,
  }));

  let dropdownDataScaleOfOrg = searchProps?.allRevenueCategory.edges.map(
    (edge) => ({
      name: edge.node.scale,
      id: edge.node.id,
    })
  );

  let dropdownDataLegalStatus = [
    "NPO",
    "認定NPO",
    "特例認定NPO",
    "一般財団",
    "公益財団",
    "一般社団",
    "公益社団",
    "学校法人",
    "なし",
    "株式会社",
    "有限会社",
    "合同会社",
  ];

  const modalToggle = () => {
    setModal(!modal);
  };

  const filterModalToggle = () => {
    setModalFilter(!modalFilter);
  };

  function cleanSentence(sentence) {
    // Remove multiple spaces
    const cleanedSentence = sentence.replace(/\s+/g, " ");

    // Remove leading whitespace
    const trimmedSentence = cleanedSentence.trim();

    return trimmedSentence;
  }

  const setFilter = async () => {
    const query = {
      name: filterInput.organizationName,
      sdgs: filterInput.sdgs?.map((item) => item.id),
      country: filterInput.country?.map((item) => item.id),
      collaborationNeeds: filterInput.collaborationNeeds?.map(
        (item) => item.id
      ),
      activityFields: filterInput.activityFields?.map((item) => item.id),
      stakeholders: filterInput.targetAudience?.map((item) => item.id),
      revenueCategories: filterInput.scaleOfOrg?.map((item) => item.id),
      networks: filterInput.networks?.map((item) => item.id),
      thirdPartyCertification: filterInput.certifications?.map(
        (item) => item.key
      ),
      entityForm: filterInput.legalStatus,
      prefecture: filterInput.address?.map((item) => item.label),
    };
    setQueryParams({
      ...Object.fromEntries(
        Object.entries(query).filter(([key, value]) => {
          if (typeof value === "string") {
            return cleanSentence(value) !== "";
          }
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return value !== undefined && value !== null;
        })
      ),
    });
    await do_search();
  };

  const do_search = () => {
    search();
    // setSearchContext("");
    window.location.href = "/#/dashboards/search";
  };
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (modalFilter && event.key === "Enter") {
        setFilter();
        filterModalToggle();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [modalFilter, filterInput, setFilter, filterModalToggle]);

  if (loadingSearchProps) {
    return (
      <div className="loading__wrapper" style={{ height: "50vh" }}>
        ......
      </div>
    );
  }

  const handleChangeFreeText = (event) => {
    filterInput[event.target.name] = event.target.value;
    setFilterInput(filterInput);
  };

  const addSdgsId = (edge) => {
    setFilterInput((prev) => ({
      ...prev,
      sdgs: [...prev.sdgs, edge],
    }));
  };

  const rmSDGsId = (target) => {
    setFilterInput((prev) => ({
      ...prev,
      sdgs: prev.sdgs.filter((item) => item.id !== target.id),
    }));
  };

  const handleCollaborationNeedsChange = (event) => {
    setFilterInput((prev) => ({
      ...prev,
      collaborationNeeds: event,
    }));
  };

  const handleChangeActs = (event) => {
    filterInput.activityFields = event;
    setFilterInput(filterInput);
  };

  const handleChangeTargetAudience = (event) => {
    filterInput.targetAudience = event;
    setFilterInput(filterInput);
  };

  const handleChangeScaleOfOrg = (event) => {
    filterInput.scaleOfOrg = event;
    setFilterInput(filterInput);
  };

  const handleChangeLegalStatus = (event) => {
    filterInput.legalStatus = event;
    setFilterInput(filterInput);
  };

  const handleChangeNetwork = (event) => {
    filterInput.networks = event;
    setFilterInput(filterInput);
  };

  const handleChangeCertification = (event) => {
    filterInput.certifications = event;
    setFilterInput(filterInput);
  };

  const handleChangePrefecture = (event) => {
    filterInput.address = event;
    setFilterInput(filterInput);
  };

  const resetFilter = () => {
    setFilterInput({
      organizationName: "",
      sdgs: [],
      country: [],
      activityFields: [],
      targetAudience: [],
      scaleOfOrg: [],
      address: [],
      legalStatus: [],
    });
    setSearchContext("");
    filterModalToggle();
  };

  return (
    <Fragment>
      <button
        className="search-icon search-icon_sp"
        onClick={() => {
          filterModalToggle();
        }}
      >
        <span />
      </button>
      <div className="search-wrapper">
        <div className="input-holder">
          <input
            placeholder="組織名で検索"
            value={queryParams?.name}
            style={{ paddingLeft: "39px" }}
            onChange={(e) => {
              filterModalToggle();
              // setQueryParams((prev) => ({
              //   ...prev,
              //   name: e.target.value,
              // }));
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                do_search();
              }
            }}
            className="search-input"
            onClick={() => {
              filterModalToggle();
            }}
          />
          <button
            className="search-icon"
            onClick={(e) => {
              // do_search();
              filterModalToggle();
            }}
          >
            <span />
          </button>
          <button
            className="search-filter-icon"
            onClick={() => {
              filterModalToggle();
            }}
          >
            <i className="pe-7s-edit"></i>
          </button>
        </div>
      </div>
      <Modal isOpen={modal} toggle={modalToggle}>
        <ModalBody className="mt-4 ml-3 mr-3">
          <h6 className="bold mb-3">組織検索</h6>
          <div className="input-holder">
            <Input
              type="text"
              className="search-input"
              placeholder="組織名 所在地 キーワード"
              value={context}
              onChange={(e) => {
                setSearchContext(e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  do_search();
                }
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
          <Button
            className="main_button"
            onClick={(e) => {
              do_search();
              modalToggle();
            }}
          >
            検索
          </Button>
        </ModalFooter>
      </Modal>
      {/* Filter Modal */}
      <Modal
        isOpen={modalFilter}
        toggle={filterModalToggle}
        style={{ top: 30 }}
      >
        <ModalBody className="mt-4 ml-3 mr-3">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              cursor: "pointer",
              marginBottom: "1rem",
              marginTop: "-1rem",
            }}
          >
            <button
              onClick={filterModalToggle}
              style={{
                background: "none",
                border: "none",
                padding: "0",
                margin: "0",
                cursor: "pointer",
                color: "#495057",
                width: "1.5rem",
                height: "1.5rem",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                fill="#495057"
              >
                <path
                  fill="#495057"
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </button>
          </div>
          <div className="input-holder">
            <FormGroup row>
              <Label sm={2}>組織名</Label>
              <Col sm={10}>
                <Input
                  placeholder="組織名 略称 等"
                  type="text"
                  // onChange={handleChangeFreeText}
                  onChange={(e) => {
                    setFilterInput((prev) => ({
                      ...prev,
                      organizationName: e.target.value,
                    }));
                    setQueryParams((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }));
                  }}
                  value={queryParams?.name || ""}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>SDGs</Label>
              <Col sm={10}>
                {searchProps &&
                  searchProps.allSdgs &&
                  searchProps.allSdgs.edges.map((item) => {
                    if (
                      filterInput.sdgs
                        .map((item) => item.id)
                        .includes(item.node.id)
                    ) {
                      return (
                        <img
                          className="px-1 mb-2 pointer"
                          style={{ width: "2.5rem" }}
                          src={item.node.logoUrl}
                          onClick={(e) => {
                            rmSDGsId(item.node);
                          }}
                          key={item.node.tile}
                        />
                      );
                    } else {
                      return (
                        <img
                          className="px-1 mb-2 pointer"
                          style={{ width: "2.5rem", opacity: "0.2" }}
                          src={item.node.logoUrl}
                          onClick={(e) => {
                            addSdgsId(item.node);
                          }}
                          key={item.node.title}
                        />
                      );
                    }
                  })}
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>連携ニーズ</Label>
              <Col sm={10}>
                <Multiselect
                  dataKey="id"
                  textField="title"
                  data={dropdownDataCollaborationNeeds}
                  placeholder="▼ 選択"
                  defaultValue={filterInput.collaborationNeeds}
                  onChange={handleCollaborationNeedsChange}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>活動国</Label>
              <Col sm={10}>
                <Multiselect
                  dataKey="id"
                  textField="nameJp"
                  placeholder="▼ 選択"
                  defaultValue={filterInput.country}
                  data={(() => {
                    const selectedIds = queryParams?.country?.map(
                      (item) => item.id
                    );
                    return availableCountries?.data?.countries?.edges
                      ?.filter((item) => {
                        return !selectedIds?.includes(item?.node?.id);
                      })
                      ?.map((country) => {
                        return {
                          nameJp: country?.node?.nameJp,
                          id: country?.node?.id,
                        };
                      });
                  })()}
                  onChange={(e) => {
                    setFilterInput((prev) => ({
                      ...prev,
                      country: e,
                    }));
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>活動分野</Label>
              <Col sm={10}>
                <Multiselect
                  dataKey="id"
                  textField="title"
                  data={dropdownDataActs}
                  placeholder="▼ 選択"
                  defaultValue={filterInput.activityFields}
                  onChange={handleChangeActs}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>対象者</Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="id"
                  textField="name"
                  data={dropdownDataTargetAudience}
                  defaultValue={filterInput.targetAudience}
                  onChange={handleChangeTargetAudience}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>組織規模</Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="id"
                  textField="name"
                  data={dropdownDataScaleOfOrg}
                  defaultValue={filterInput.scaleOfOrg}
                  onChange={handleChangeScaleOfOrg}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label
                sm={2}
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                ネットワーク
              </Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="id"
                  textField="name"
                  data={networksOptions}
                  onChange={handleChangeNetwork}
                  defaultValue={filterInput.networks}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label
                sm={2}
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                第三者認証
              </Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="key"
                  textField="title"
                  data={certificationsOptions}
                  onChange={handleChangeCertification}
                  defaultValue={filterInput.certifications}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>国内所在地</Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="label"
                  textField="label"
                  data={prefectureOptions.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  onChange={handleChangePrefecture}
                  defaultValue={filterInput.address}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>法人格</Label>
              <Col sm={10}>
                <Multiselect
                  placeholder="▼ 選択"
                  dataKey="id"
                  textField="color"
                  data={dropdownDataLegalStatus}
                  onChange={handleChangeLegalStatus}
                  defaultValue={filterInput.legalStatus}
                />
              </Col>
            </FormGroup>
          </div>
        </ModalBody>
        <div className="d-none d-sm-block">
          <ModalFooter
            className="ml-3 mr-3"
            style={{ background: "#fff", borderTop: "none" }}
          >
            <Button
              size="lg"
              onClick={(e) => {
                filterModalToggle();
              }}
            >
              キャンセル
            </Button>
            <Button
              size="lg"
              onClick={(e) => {
                resetFilter();
              }}
            >
              リセット
            </Button>
            <Button
              size="lg"
              onClick={(e) => {
                setFilter();
                filterModalToggle();
              }}
            >
              検索
            </Button>
          </ModalFooter>
        </div>
        <div className="d-block d-sm-none">
          <ModalFooter
            className="ml-3 mr-3"
            style={{
              background: "#fff",
              borderTop: "none",
              justifyContent: "normal",
              display: "block",
            }}
          >
            <Button
              block
              size="lg"
              onClick={(e) => {
                filterModalToggle();
              }}
            >
              キャンセル
            </Button>
            <Button
              block
              size="lg"
              onClick={(e) => {
                setFilter();
                filterModalToggle();
              }}
              style={{ marginLeft: 0 }}
            >
              検索
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </Fragment>
  );
};

export default SearchBox;
